import { affiliationDataAtom, type UserAffiliation, userInfoDecodedDataAtom } from '@capsicum/common';
import { partnerWebAppAtom, useRouter } from '@capsicum/common-web';
import { useAtom, useSetAtom } from 'jotai';
import { useEffect } from 'react';

export const usePartnerWebAppInitializer = () => {
	const { searchParams } = useRouter();
	const [partnerWebApp, setPartnerWebApp] = useAtom(partnerWebAppAtom);
	const setAffiliationData = useSetAtom(affiliationDataAtom);
	const setUserInfoDecodedDataAtom = useSetAtom(userInfoDecodedDataAtom);

	const partnerWebAppId = searchParams.get('partnerWebAppId');
	const userInfoBase64 = searchParams.get('userInfo');

	const affiliationDataFromUrl = {
		campaign: searchParams.get('campaign') || undefined,
		param1: searchParams.get('param1') || undefined,
		param2: searchParams.get('param2') || undefined,
		param3: searchParams.get('param3') || undefined,
		referrer: searchParams.get('referrer') || undefined
	} as UserAffiliation;

	useEffect(() => {
		if (!partnerWebApp.hasCheckedBeenDone) {
			setPartnerWebApp({
				hasCheckedBeenDone: true,
				partnerWebAppId
			});
			if (Object.keys(affiliationDataFromUrl).length) {
				setAffiliationData(affiliationDataFromUrl);
			}
			if (userInfoBase64) {
				const userInfoDecodedData = Buffer.from(userInfoBase64, 'base64').toString('ascii');

				setUserInfoDecodedDataAtom(JSON.parse(userInfoDecodedData));
			}
		}
	}, []);

	return {
		isPartnerWebApp: Boolean(partnerWebAppId) || Boolean(partnerWebApp.partnerWebAppId)
	};
};
